// src/components/LanguageSwitcher.js
import { useState } from 'react'
import { useLang, LANGUAGES } from '../lib/i18n'
import './LanguageSwitcher.css'

export default function LanguageSwitcher() {
  const { lang, changeLang } = useLang()
  const [open, setOpen] = useState(false)
  const current = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0]

  return (
    <div className="lang-sw">
      <button className="lang-sw__btn" onClick={() => setOpen(o => !o)}>
        <span>{current.flag}</span>
        <span className="lang-sw__code">{current.code.toUpperCase()}</span>
        <span className="lang-sw__arrow">{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <>
          <div className="lang-sw__backdrop" onClick={() => setOpen(false)} />
          <div className="lang-sw__dropdown">
            {LANGUAGES.map(l => (
              <button key={l.code}
                className={`lang-sw__opt ${lang === l.code ? 'lang-sw__opt--active' : ''}`}
                onClick={() => { changeLang(l.code); setOpen(false) }}>
                <span>{l.flag}</span>
                <span>{l.label}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
